import { CountryCode } from '@constants'
import { getCountryCodeFromPathname } from '@utils'

export const getWpUserRegion = (): CountryCode => {
  return getCountryCodeFromPathname(window.location.pathname, CountryCode.TW) as CountryCode
}
